import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import PacienteDetalhes from './pages/PacienteDetalhes';
import Exames from './pages/Exames';
import ExameDetalhes from './pages/ExameDetalhes';
import Solicitacoes from './pages/Solicitacoes';
import ProtocoloDetalhes from './pages/ProtocoloDetalhes';
import Atendimentos from './pages/Atendimentos';
import AtendimentoDetalhes from './pages/AtendimentoDetalhes';
import ColetasDomiciliares from './pages/ColetasDomiciliares';
import ColetaDomiciliarDetalhes from './pages/ColetaDomiciliarDetalhes';
import AgendamentosColeta from './pages/AgendamentosColeta';
import ColetaPublica from './pages/ColetaPublica';
import Orcamentos from './pages/Orcamentos';
import OrcamentoDetalhes from './pages/OrcamentoDetalhes';
import Resultados from './pages/Resultados';
import ResultadoDetalhes from './pages/ResultadoDetalhes';
import Financeiro from './pages/Financeiro';
import FinanceiroPixConfig from './pages/FinanceiroPixConfig';
import Aparelhos from './pages/Aparelhos';
import Setores from './pages/Setores';
import Locais from './pages/Locais';
import Laboratorios from './pages/Laboratorios';
import TabelasExplorer from './pages/TabelasExplorer';
import Medicos from './pages/Medicos';
import Laudos from './pages/Laudos';
import LaudoDetalhes from './pages/LaudoDetalhes';
import LabApoio from './pages/LabApoio';
import ApiDocs from './pages/ApiDocs';
import GerenciarPerfis from './pages/GerenciarPerfis';
import GerenciarUsuarios from './pages/GerenciarUsuarios';
import Convenios from './pages/Convenios';
import ConvenioDetalhes from './pages/ConvenioDetalhes';
import MateriaisMetodos from './pages/MateriaisMetodos';
import Responsaveis from './pages/Responsaveis';
import Bancadas from './pages/Bancadas';
import Recipientes from './pages/Recipientes';
import Faturamento from './pages/Faturamento';
import RelatorioFaturamento from './pages/RelatorioFaturamento';
import ConferenciaConvenios from './pages/ConferenciaConvenios';
import ConferenciaHospital from './pages/ConferenciaHospital';
import TabelaUnimed from './pages/TabelaUnimed';
import WhatsAppConfig from './pages/WhatsAppConfig';
import WhatsAppEnvios from './pages/WhatsAppEnvios';
import WhatsAppDashboard from './pages/WhatsAppDashboard';
import WhatsAppAgente from './pages/WhatsAppAgente';
import WhatsAppMensagens from './pages/WhatsAppMensagens';
import WhatsAppConversas from './pages/WhatsAppConversas';
import WhatsAppContatos from './pages/WhatsAppContatos';
import WhatsAppContatoDetalhes from './pages/WhatsAppContatoDetalhes';
import WhatsAppHistorico from './pages/WhatsAppHistorico';
import WhatsAppDiagnostico from './pages/WhatsAppDiagnostico';
import PainelGestor from './pages/PainelGestor';
import PainelAdministrativo from './pages/PainelAdministrativo';
import PainelInconsistencias from './pages/PainelInconsistencias';
import TempoExames from './pages/TempoExames';
import TempoExameDetalhe from './pages/TempoExameDetalhe';
import TissUnimed from './pages/TissUnimed';
import TissProtocoloDetalhes from './pages/tiss-unimed/ProtocoloDetalhes';
import TissLoteDetalhes from './pages/tiss-unimed/LoteDetalhes';
import IpsemgTes from './pages/IpsemgTes';
import TesteIA from './pages/TesteIA';
import TesteIADetalhe from './pages/TesteIADetalhe';
import TesteIAAnalises from './pages/TesteIAAnalises';
import TesteIAAnaliseDetalhe from './pages/TesteIAAnaliseDetalhe';
import TesteAgente from './pages/TesteAgente';
import './AppNew.css';

function AppNew() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Rota de Login */}
          <Route path="/login" element={<Login />} />

          {/* Página pública de coleta domiciliar (sem auth) */}
          <Route path="/coleta-publica/:token" element={<ColetaPublica />} />

          {/* Página pública de teste do agente IA (auth Google própria) */}
          <Route path="/teste-agente" element={<TesteAgente />} />

          {/* Todas as rotas protegidas */}
          <Route path="/*" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <main className="main-container">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/painel-administrativo" element={<PainelAdministrativo />} />
                    <Route path="/painel-gestor" element={<PainelGestor />} />
                    <Route path="/painel-inconsistencias" element={<PainelInconsistencias />} />
                    <Route path="/pacientes" element={<Pacientes />} />
                    <Route path="/pacientes/:id" element={<PacienteDetalhes />} />
                    <Route path="/solicitacoes" element={<Solicitacoes />} />
                    <Route path="/protocolo/:protocolo" element={<ProtocoloDetalhes />} />
                    <Route path="/atendimentos" element={<Atendimentos />} />
                    <Route path="/atendimentos/:id" element={<AtendimentoDetalhes />} />
                    <Route path="/coletas-domiciliares" element={<ColetasDomiciliares />} />
                    <Route path="/coletas-domiciliares/:id" element={<ColetaDomiciliarDetalhes />} />
                    <Route path="/agendamentos-coleta" element={<AgendamentosColeta />} />
                    <Route path="/orcamentos" element={<Orcamentos />} />
                    <Route path="/orcamentos/:id" element={<OrcamentoDetalhes />} />
                    <Route path="/resultados" element={<Resultados />} />
                    <Route path="/resultados/:atendimentoId" element={<ResultadoDetalhes />} />
                    <Route path="/lab-apoio" element={<LabApoio />} />
                    <Route path="/financeiro" element={<Financeiro />} />
                    <Route path="/financeiro/pix-config" element={<FinanceiroPixConfig />} />
                    <Route path="/exames" element={<Exames />} />
                    <Route path="/exames/:id" element={<ExameDetalhes />} />
                    <Route path="/aparelhos" element={<Aparelhos />} />
                    <Route path="/setores" element={<Setores />} />
                    <Route path="/locais" element={<Locais />} />
                    <Route path="/laboratorios" element={<Laboratorios />} />
                    <Route path="/medicos" element={<Medicos />} />
                    <Route path="/laudos" element={<Laudos />} />
                    <Route path="/laudos/:id" element={<LaudoDetalhes />} />
                    <Route path="/tabelas" element={<TabelasExplorer />} />
                    <Route path="/api-docs" element={<ApiDocs />} />
                    <Route path="/perfis" element={<GerenciarPerfis />} />
                    <Route path="/usuarios" element={<GerenciarUsuarios />} />
                    <Route path="/convenios" element={<Convenios />} />
                    <Route path="/convenios/:id" element={<ConvenioDetalhes />} />
                    <Route path="/materiais-metodos" element={<MateriaisMetodos />} />
                    <Route path="/responsaveis" element={<Responsaveis />} />
                    <Route path="/bancadas" element={<Bancadas />} />
                    <Route path="/recipientes" element={<Recipientes />} />
                    <Route path="/faturamento" element={<Faturamento />} />
                    <Route path="/relatorio-faturamento" element={<RelatorioFaturamento />} />
                    <Route path="/conferencia-convenios" element={<ConferenciaConvenios />} />
                    <Route path="/conferencia-hospital" element={<ConferenciaHospital />} />
                    <Route path="/tabela-unimed" element={<TabelaUnimed />} />
                    <Route path="/whatsapp-config" element={<WhatsAppConfig />} />
                    <Route path="/whatsapp-envios" element={<WhatsAppEnvios />} />
                    <Route path="/whatsapp-dashboard" element={<WhatsAppDashboard />} />
                    <Route path="/whatsapp-mensagens" element={<WhatsAppMensagens />} />
                    <Route path="/whatsapp-agente" element={<WhatsAppAgente />} />
                    <Route path="/whatsapp-conversas" element={<WhatsAppConversas />} />
                    <Route path="/whatsapp-conversas/:phone" element={<WhatsAppConversas />} />
                    <Route path="/whatsapp-contatos" element={<WhatsAppContatos />} />
                    <Route path="/whatsapp-contatos/:phone" element={<WhatsAppContatoDetalhes />} />
                    <Route path="/whatsapp-historico" element={<WhatsAppHistorico />} />
                    <Route path="/whatsapp-diagnostico" element={<WhatsAppDiagnostico />} />
                    <Route path="/tempo-exames" element={<TempoExames />} />
                    <Route path="/tempo-exames/:codigo" element={<TempoExameDetalhe />} />
                    <Route path="/tiss-unimed" element={<TissUnimed />} />
                    <Route path="/tiss-unimed/protocolo/:local/:protocolo" element={<TissProtocoloDetalhes />} />
                    <Route path="/tiss-unimed/lote/:id" element={<TissLoteDetalhes />} />
                    <Route path="/ipsemg" element={<IpsemgTes />} />
                    <Route path="/teste-ia" element={<TesteIA />} />
                    <Route path="/teste-ia/analises" element={<TesteIAAnalises />} />
                    <Route path="/teste-ia/analises/:id" element={<TesteIAAnaliseDetalhe />} />
                    <Route path="/teste-ia/:id" element={<TesteIADetalhe />} />
                  </Routes>
                </main>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default AppNew;
